namespace InvData.ModelEnvironmentHelper {

    function isNotNull(obj) {
        return typeof obj !== "undefined" && obj !== null;  
    }

    /**
     * Iterate over child investments and call callback for each investment (excluding the internal edges if
     * we are looking through aggregate views).
     * @param options
     */
    export function forEachChildInvestment(
        options: {
            callback: (childInvestment: any) => void,
            modelEnv: ModelEnvironment,
            lookThroughAggregateViews?: boolean,
            maxLookThroughDepth?: number,
            rootEntityId: number
        }
    ) {

        var callback = options.callback;
        var modelEnv = options.modelEnv;
        var lookThroughAggregateViews = options.lookThroughAggregateViews ? true : false;
        var maxLookThroughDepth = isNotNull(options.maxLookThroughDepth) ? options.maxLookThroughDepth : null;

        var internalForEachChildInvestment = function (entityId, depth) {
            var childInvestments = modelEnv.getInvestmentsForOwnerId(entityId);
            if (childInvestments) {
                for (let childInvestment of childInvestments) {
                    if (!lookThroughAggregateViews
                        || (isNotNull(maxLookThroughDepth) && depth >= maxLookThroughDepth)) {
                        // We are not looking through aggregate views, or we are at max-depth.
                        callback(childInvestment);
                    }
                    else {
                        var holding = modelEnv.getEntityById(childInvestment.holdingId);
                        if (holding == null) {
                            // The holding was not loaded, so we can't know if it is
                            // an aggregate view, so we just add the investment id to the list.
                            callback(childInvestment);
                        }
                        else {
                            if (InvData.SpecialEntityTypeIds.isAggregateView(holding.seTypeId)) {
                                // Holding is an aggregate view, so we need to do a look-through.
                                internalForEachChildInvestment(holding.id, depth + 1);
                            }
                            else {
                                // Holding is not an aggregate view, so add it to the list.
                                callback(childInvestment);
                            }
                        }
                    }
                }
            }
        };

        internalForEachChildInvestment(options.rootEntityId, 1);
    }

}